<template>
<section class="full-width-photo p-4">
    <SmoothLoader class="max-w-4xl mx-auto flex flex-wrap justify-center">
        <img :src="photo.src" :alt="photo.alt">
        <div v-if="caption" class="mt-2">
            <p class="caption text-center text-gray-300 text-xs font-headline w-full" v-html="caption"></p>
        </div>
    </SmoothLoader>
</section>
</template>

<script>
export default {

    props: ['data'],
    
    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>